<!-- @Version: 1.0.3 -->
<div class="fileuploadcontainer" [class]="position" cdkTrapFocus>

  <div mat-field-background class="filednD border" [class]="sFileupload.error ? 'error' : ''" [dndDropzone]="[]" [dndAllowExternal]="true" [dndDisableIf]="disabled || readonly" (dndDrop)="onDrop($event)">
    <div class="icon">
      <mat-icon [inline]="true" [color]="TRANSLATE_PATH.COLOR_ICON | translateDesign" data-testid="upload_icon">{{content.icon}}</mat-icon>
    </div>
    <p class="headline-3" data-testid="headline" [attr.color]="TRANSLATE_PATH.COLOR_TITLE| translateDesign" >{{ content.title }}@if (sIsRequired.required) {
      *
    }</p>
    <p class="body-2" data-testid="text_1">MAX {{ sFileupload.formatBytes(maxFilesize) }} - {{ allowedExtensions.join(', ') }}</p>
    <p class="body-1" data-testid="text_2">{{ actMaxNumberOfFiles }} - Dokument erlaubt</p>
    <button mat-raised-button data-testid="fileupload_btn" [color]="!sFileupload.error? 'white':'warn'" (click)="uploadInputRef.click()" [disabled]="disabled || readonly">
      <span >{{ content.button }}</span>
      <input type="file" #uploadInputRef multiple id="fileUpload" (change)="addFile($event)">
    </button>
    @if (isError(FIELUPLOAD_ERROR.AMOUNTTOBIG)) {
      <mat-error data-testid="error_amount" >{{ content.amountToBig }}</mat-error>
    }
    @if (isError(FIELUPLOAD_ERROR.NOCHOICE)) {
      <mat-error data-testid="error_choice" >{{ content.noChoice }}</mat-error>
    }
    @if (isError(FIELUPLOAD_ERROR.MAXSIZE)) {
      <mat-error data-testid="error_size" >{{ content.maxSize }}</mat-error>
    }
    @if (isError(FIELUPLOAD_ERROR.FILETYPE)) {
      <mat-error data-testid="error_type" >{{ content.fileType }}</mat-error>
    }
    @if (isError(FIELUPLOAD_ERROR.REQUIRED)) {
      <mat-error data-testid="error_required" >{{ content.required }}</mat-error>
    }
    @if (isError(FIELUPLOAD_ERROR.FILENAMEISINVALID)) {
      <mat-error data-testid="error_filename" >{{ content.filenameIsInvalid }}</mat-error>
    }
  </div>
  @if (dataUrlSave && dataUrlSave.length > 0) {
    <div class="filesListed">
      @for (file of dataUrlSave; track file; let i = $index) {
        <div class="row">
          <div data-min-width="20px" data-max-width="20px" class="cursor" (click)="file.openFile()">
            <mat-icon [inline]="true" [color]="TRANSLATE_PATH.COLOR_ICON | translateDesign" >remove_red_eye</mat-icon>
          </div>
          <div>{{ file.filename}}</div>
          <div>{{ sFileupload.formatBytes(file.size) }}</div>
          <div data-min-width="20px" data-max-width="20px" class="cursor" (click)="removeFile(i)">
            <mat-icon [inline]="true" [color]="TRANSLATE_PATH.COLOR_ICON | translateDesign"  >delete</mat-icon>
          </div>
        </div>
      }
    </div>
  }
</div>


